DatabaseGetDocumentController.$inject= ['DatabaseService'];
export default function DatabaseGetDocumentController(DatabaseService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.mode = (ctrl.mode) ? ctrl.mode : 'full';
        ctrl.schema = (ctrl.schema) ? ctrl.schema : 'bib';
        ctrl.record = {};
    };

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.database = changes.database.currentValue;
            ctrl.docid = changes.docid.currentValue;
            load();
        }
    };

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    function load() {
        var qs = {
            id: ctrl.database,
            command: 'search',
            query: '@1=12 "' + ctrl.docid.replace(/\\/g, '\\\\') + '"',
            maximumRecords: 1,
            recordSchema: ctrl.schema
        };
        ctrl.isProcess = true;
        DatabaseService.get(qs).$promise.then(function(response) {
            if (response.success) {
                ctrl.record = response.data.records[0].recordData;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };
}
